module.exports = __webpack_public_path__ + "static/todolistWithMongo-facc0a9508f13f47c5162c535167cde9.png";